import { z } from 'zod'

const InventoryItemBaseDtoSchema = z.object({
  id: z.string(),
  type: z.enum(['booster', 'free_bet']),
  playerId: z.string(),
  status: z.enum(['claimable', 'claimed', 'applied', 'used', 'expired', 'cancelled']),
  createdAt: z.string(),
  expiresAt: z.string().optional().nullable(),
  claimedAt: z.string().optional().nullable(),
  applicableGames: z.array(z.string()),
  quantity: z.number().optional(),
  tags: z.array(z.string()),
  originType: z.string(),
  originId: z.string()
})

const InventoryBoosterItemDtoSchema = InventoryItemBaseDtoSchema.extend({
  boost: z.object({
    value: z.number(),
    unit: z.enum(['percentage', 'fixed'])
  }),
  activationType: z.enum(['auto', 'manual'])
})

const InventoryBonusItemDtoSchema = InventoryItemBaseDtoSchema.extend({
    amount: z.number(),
    currency: z.string()
})

// Union type that matches backend's flattened structure
export const InventoryItemDtoSchema = z.union([
  InventoryBoosterItemDtoSchema,
  InventoryBonusItemDtoSchema,
  InventoryItemBaseDtoSchema // Fallback for items without type-specific data
])

export const InventoryResponseDtoSchema = z.object({
  items: z.array(InventoryItemDtoSchema).optional().default([])
})
